'use client'

import TopNavigation from './TopNavigation'
import { PageHeaderProvider } from '@/contexts/PageHeaderContext'
import GlobalLoadingIndicator from './ui/GlobalLoadingIndicator'

interface AppLayoutProps {
  children: React.ReactNode
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <PageHeaderProvider>
      <div className="min-h-screen bg-gray-50">
        {/* Global Loading Indicator */}
        <GlobalLoadingIndicator />
        
        {/* Top Navigation */}
        <TopNavigation />

        {/* Main Content */}
        <main className="flex-1">
          {children}
        </main>
      </div>
    </PageHeaderProvider>
  )
}
